<template>
    <div v-if="storage" class="hard-drive-select-component">
        <div class="hard-drive-select-heading">
            <h3>Add External Storage?</h3>
            <a class="hard-drive_scroll" v-if="showSeeMore" v-scroll-to="'#external-drive'">See More</a>
        </div>

        <div :class="{ selected: selectedStorage && selectedStorage.id != 0 }" class="hard-drive-select">
            <multiselect
                :allow-empty="false"
                :internal-search="false"
                :options="storage"
                :searchable="false"
                :show-labels="false"
                :value="selectedStorage"
                label="title"
                track-by="id"
                @input="changeStorage"
            >
                <template slot="singleLabel" slot-scope="props">
                    {{ props.option.title }}
                    <template v-if="props.option.id != 0">
                        {{ props.option.variants[0].capacity }}
                        - {{ props.option.variants[0].price | formatMoney }}
                    </template>
                </template>
                <template slot="option" slot-scope="props">
                    <span>
                        {{ props.option.title }}
                        <template v-if="props.option.id != 0">
                            {{ props.option.variants[0].capacity }}
                            - {{ props.option.variants[0].price | formatMoney }}
                        </template>
                    </span>
                </template>
            </multiselect>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
    name: "HardDriveSelect",
    props: {
        showSeeMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            storage: "StarterPc/getExternalStorage"
        }),
        ...mapState({
            cart: state => state.StarterPc.cart,
            isUpdating: state => state.StarterPc.isUpdating,
            selectedStorage: state => state.StarterPc.selectedStorage
        })
    },
    methods: {
        ...mapActions({
            removePart: "StarterPc/removePart",
            setSelectedStorage: "StarterPc/setSelectedStorage",
            updatePart: "StarterPc/updatePart"
        }),
        changeStorage(storage) {
            if (storage.id == 0) {
                this.removePart(this.selectedStorage.variants[0]).then(() => {
                    this.setSelectedStorage(storage);
                });
            } else {
                if (this.selectedStorage.id == 0 || this.selectedStorage.variants[0].products_id == storage.variants[0].products_id) {
                    this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                        this.setSelectedStorage(storage);
                    });
                } else {
                    this.removePart(this.selectedStorage.variants[0]).then(() => {
                        this.updatePart({ part: storage.variants[0], qty: 1 }).then(() => {
                            this.setSelectedStorage(storage);
                        });
                    });
                }
            }
        }
    }
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.hard-drive_scroll {
    cursor: pointer;
}

.hard-drive-select-heading {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    h3 {
        text-transform: uppercase;
        margin: 0;

        @media (max-width: 580px) {
            font-size: 20px;
        }
    }

    a {
        font-size: 16px;
        color: $orchid;

        @media (max-width: 580px) {
            font-size: 14px;
        }
    }
}

.hard-drive-select {
    .multiselect {
        cursor: pointer;
        text-align: center;

        &__tags {
            background-color: transparent;
            border: 3px solid rgba(218, 221, 224, 0.6);
            border-radius: 0;

            .multiselect__placeholder,
            .multiselect__single {
                color: $white;
            }

            .multiselect__single {
                background-color: transparent;
                padding: 11px 0;
            }
        }

        &__select {
            &::before {
                position: absolute;
                right: 13px;
                top: 25px;
                border-color: transparent transparent #999;
                border-style: solid;
                border-width: 0 5px 5px;
                content: "";
                margin-top: 0;
            }

            &::after {
                position: absolute;
                right: 13px;
                top: 32px;
                border-color: #999 transparent transparent;
                border-style: solid;
                border-width: 5px 5px 0;
                content: "";
            }
        }

        &__option {
            min-height: 48px;

            span {
                line-height: 24px;
            }

            &--highlight {
                background: #51007a;
                outline: none;
                color: #fff;
            }

            &--selected {
                &.multiselect__option--highlight {
                    background: #f3f3f3;
                    color: #35495e;
                    cursor: default;
                }
            }
        }

        &--active {
            .multiselect__select {
                transform: rotate(0)
            }
        }
    }

    &.selected {
        .multiselect {
            &__tags {
                border-color: $orchid;

                .multiselect__placeholder,
                .multiselect__single {
                    color: $orchid;
                }
            }

            &__select {
                &::before {
                    border-bottom-color: $orchid;
                }

                &::after {
                    border-top-color: $orchid;
                }
            }
        }
    }
}

.buy-options-hard-drive-select {
    .hard-drive-select {
        .multiselect {
            &__tags {
                .multiselect__placeholder,
                .multiselect__single {
                    color: #000;
                }
            }
        }

        &.selected {
            .multiselect {
                &__tags {
                    .multiselect__placeholder,
                    .multiselect__single {
                        color: $orchid;
                    }
                }
            }
        }
    }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait) {
    .hard-drive-select-component{
        width: 100%;
    }
}
</style>
